(function() { window.GUID_ca47069f_1273_4535_b124_712bc590f65b = { getGuid: function() { return "ca47069f-1273-4535-b124-712bc590f65b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RatingPopup extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            constructor(controlId) {
                super(controlId);
                this.controlId = controlId;
            }
            OnControlInstantiation(params) { }
            OnBindEvents() { }
            OnDispose() { }
        }
        Controls.RatingPopup = RatingPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=RatingPopup.js.map
